<template>
  <div :id="localeClass" class="platform__pc">
    <template v-if="isLogin">
      <nuxt />
    </template>
    <template v-else>
      <DefaultGuideLogin />
    </template>
    <no-ssr>
      <!-- 登录及绑定邮箱弹窗 -->
      <LoginDialog :show.sync="showLoginDialog" :success-url="loginSuccessUrl" :trigger-src="loginTriggerSrc" :login-trigger-source="loginTriggerSource" :is-group="isGroup" />
    </no-ssr>
  </div>
</template>

<script>
import bus from 'common/bus';
import LoginDialog from 'components/login/LoginDialog/index.vue';
import DefaultGuideLogin from 'components/common/DefaultGuideLogin/index.vue';

export default {
  components: {
    LoginDialog, DefaultGuideLogin,
  },
  data() {
    return {
      // 登录弹窗
      showLoginDialog: false,
      loginSuccessUrl: '',
      loginTriggerSource: '',
      bindEmailSuccessUrl: '',
      loginTriggerSrc: '',
      isGroup: false,
    }
  },
  computed: {
    /**
     * 当前语言环境样式名
     * 可通过此样式名叠加样式实现不同语言样式
     */
    localeClass() {
      return `locale__${this.$store.state.locale}`;
    },
    /**
     * 登录态
     */
    isLogin() {
      return this.$store.state.ucenter.isLogin;
    },
  },
  watch: {
    isLogin(newVal) {
      if (!newVal) {
        this.login()
      }
    },
  },
  mounted() {
    console.log('onlyLoginLayout mounted')
    // 页面刷新强制跳转到页面顶部
    document.documentElement.scrollTop = 0;

    if (!this.isLogin) this.login()
    // 登录弹窗
    bus.$on('login', (argsObj) => {
      if (argsObj && argsObj.triggerSrc) {
        this.loginTriggerSrc = argsObj.triggerSrc;
      }
      if (argsObj && argsObj.triggerSource) {
        this.loginTriggerSource = argsObj.triggerSource
      }
      if (argsObj && argsObj.successUrl) {
        this.loginSuccessUrl = argsObj.successUrl;
      }
      if (argsObj && argsObj.isGroup) {
        this.isGroup = argsObj.isGroup;
      }
      this.login();
    });
  },
  destroyed() {
    // 页面销毁的时候取消监听
    bus.$off('login')
  },
  methods: {
    login() {
      this.showLoginDialog = true;
    },
  },
}
</script>

<style lang="scss" scoped>
.personal-center-body-wrapper {
  height: 100%;
  padding: 40px 0 79px;
  background: #fff;

  .side-nav-bar-container {
    margin-right: 24px;
  }

  .page-template-container {
    position: relative;
    width: 878px;
    min-height: 100%;
    background: #fafafa;
    border-radius: 8px;
    overflow: hidden;
  }
}
</style>
